import { findProjectInList, getProjectId } from './projectUtils';

/**
 * Reconcile localStorage/app selectedProject against GET /projects results.
 * localStorage is untrusted; never keep a project that is not in the accessible list.
 */
export function reconcileSelectedProject(projects, selectedProject) {
  const list = Array.isArray(projects) ? projects : [];

  if (!list.length) {
    return { project: null, nextStep: 'project-selection' };
  }

  if (!selectedProject) {
    if (list.length === 1) {
      return { project: list[0], nextStep: 'replace' };
    }
    return { project: null, nextStep: 'project-selection' };
  }

  const match = findProjectInList(list, selectedProject);
  if (match) {
    return { project: match, nextStep: 'continue' };
  }

  if (list.length === 1) {
    return { project: list[0], nextStep: 'replace' };
  }

  return { project: null, nextStep: 'project-selection' };
}

export function isProjectInAccessibleList(projects, selectedProject) {
  if (!selectedProject) return false;
  return Boolean(findProjectInList(projects, selectedProject));
}

export function getAccessibleProjectIds(projects) {
  return (Array.isArray(projects) ? projects : [])
    .map((project) => getProjectId(project))
    .filter((projectId) => projectId != null)
    .map(String);
}
